import * as S from "./styles";

export type LoaderProps = {
  size?: number;
  color?: string;
};

export default function Loader({ size = 32, color = "#fff" }: LoaderProps) {
  return (
    <S.Wrapper>
      <S.Spinner
        style={{ fontSize: `${size}px`, color: color }}
        color={color}
        role="loader"
      />
    </S.Wrapper>
  );
}
